const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgInternacional(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b9eff7e7-1944-479f-a34f-6f662513398a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bf273428-35ce-4420-89a6-92c335c94bf0{fill:#045688;}.a8f7e3db-153d-4fbc-9d90-f33221c9311c{fill:#fff;}")), /*#__PURE__*/React.createElement("rect", {
    className: "bf273428-35ce-4420-89a6-92c335c94bf0",
    width: 52,
    height: 52,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "a8f7e3db-153d-4fbc-9d90-f33221c9311c",
    d: "M14.77,25.3a23,23,0,0,1,7.49-3.47,6.71,6.71,0,0,1,5.11.34,5.19,5.19,0,0,1,2.92,4.32A20.1,20.1,0,0,1,28.42,37a13.55,13.55,0,0,1-1.49,2.33,3.56,3.56,0,0,1-3.6,1.45,15.2,15.2,0,0,1-12.59-12,14.71,14.71,0,0,1,7.72-15.88,18.13,18.13,0,0,1,3.91-1.49,4.5,4.5,0,0,1,5.32,3.71,3.65,3.65,0,0,1-2.74,4,25,25,0,0,0-8.39,4.24c-.69.55-1.32,1.16-2,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a8f7e3db-153d-4fbc-9d90-f33221c9311c",
    d: "M26.11,41c3.84-1.48,5.35-4.72,6.43-8.24a22,22,0,0,0,.82-8.51c-.18-2.06,1.18-3.19,3.12-2.48a13.25,13.25,0,0,1,3.43,1.81c1.88,1.41,1.78,3.45,1.32,5.5A15.24,15.24,0,0,1,27.34,40.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a8f7e3db-153d-4fbc-9d90-f33221c9311c",
    d: "M26.07,11.05c6.14-.62,13.63,4.69,14.83,11.06a9.74,9.74,0,0,0-7.46-4,2.63,2.63,0,0,1-2.1-1.58A16.91,16.91,0,0,0,28.89,13,15.64,15.64,0,0,0,26.07,11.05Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternacional);
export default __webpack_public_path__ + "static/media/INTERNACIONAL.2c92c06484461e1e156c43cf82c276da.svg";
export { ForwardRef as ReactComponent };